import React, { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

const items: FaqItem[] = [
  {
    q: 'Come posso prenotare il primo colloquio?',
    a: 'Il primo colloquio è gratuito e puoi prenotarlo direttamente dal sito oppure contattandomi tramite WhatsApp. Gli incontri si svolgono online, preferibilmente su Google Meet, o eventualmente su WhatsApp Video.',
  },
  {
    q: 'Quanto durano le sedute e con quale frequenza?',
    a: "Le sedute hanno una durata di 45 minuti e si svolgono generalmente una volta a settimana, salvo diversa necessità condivisa. Durante il primo incontro definiremo insieme la frequenza, l'orario più adatto e il funzionamento del setting online.",
  },
  {
    q: 'Come avviene il pagamento?',
    a: 'Il pagamento avviene a fine mese tramite bonifico bancario, con rilascio di fattura sanitaria detraibile nella dichiarazione dei redditi.',
  },
  {
    q: 'Posso disdire o spostare una seduta?',
    a: "È possibile disdire o spostare una seduta, purché la comunicazione avvenga con almeno 24 ore di anticipo, in modo da evitare l'addebito dell'appuntamento.",
  },
  {
    q: 'Cosa firmiamo prima di iniziare?',
    a: 'Una volta concordati gli aspetti pratici, ti invierò i moduli per il consenso informato e la privacy, come previsto dal codice deontologico.',
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-28 bg-cream border-t border-forest/5 overflow-hidden">
      <div
        className="absolute right-0 top-20 w-80 h-80 rounded-full bg-sage/8 blur-3xl pointer-events-none"
        data-parallax="0.05"
        style={{ transform: 'translateY(var(--py, 0))' }}
        aria-hidden
      />
      <div
        className="absolute -left-20 sm:-left-32 bottom-10 w-[260px] h-[260px] md:w-[360px] md:h-[360px] rounded-full bg-clay/8 blur-3xl pointer-events-none"
        data-parallax="0.04"
        style={{ transform: 'translateY(var(--py, 0))' }}
        aria-hidden
      />

      <div className="max-w-5xl mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-4 reveal">
            <div className="flex items-baseline gap-4">
              <span className="font-serif text-5xl italic text-sage/70 leading-none">03</span>
              <span className="text-xs uppercase tracking-[0.3em] text-clay font-semibold">Domande</span>
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="reveal font-serif text-4xl md:text-5xl text-forestDark leading-[1.1] tracking-tight" style={{ ['--d' as any]: '80ms' }}>
              Tutto ciò che serve sapere <em className="italic font-light text-sage">prima di iniziare</em>.
            </h2>
          </div>
        </div>

        <div className="space-y-2">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="reveal border-b border-forest/10"
                style={{ ['--d' as any]: `${i * 60}ms` }}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-start justify-between gap-6 py-5 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-start gap-4 flex-1">
                    <span className="mt-[0.6rem] w-1.5 h-1.5 rounded-full bg-clay group-hover:bg-clayDark smooth-transition shrink-0" aria-hidden />
                    <span className="font-serif text-lg md:text-xl text-forestDark group-hover:text-forest smooth-transition">
                      {item.q}
                    </span>
                  </span>
                  <span
                    className={`mt-1 w-7 h-7 rounded-full border flex items-center justify-center shrink-0 smooth-transition ${isOpen ? 'bg-clay border-clay text-cream rotate-45' : 'border-forest/20 text-forest'}`}
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14M5 12h14" /></svg>
                  </span>
                </button>
                <div
                  className="grid overflow-hidden transition-[grid-template-rows] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="overflow-hidden">
                    <p className="text-sm text-charcoal/75 leading-relaxed pl-10 pr-12 pb-6 max-w-3xl">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
